import React, { useEffect, useState, useRef, createContext } from "react"
import { apiEndpoint } from "helpers/url_helper";

import MetaTags from 'react-meta-tags';
import Select from "react-select";
import moment from "moment";
import {
    Col,
    Row,
    Card,
    CardBody,
    Button,
    ButtonGroup,
    UncontrolledTooltip,
} from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"
import BootstrapTable from "react-bootstrap-table-next"
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
//import ReactToPrint from "react-to-print";
const { SearchBar } = Search;
import ReactBSAlert from "react-bootstrap-sweetalert";
import { connect } from "react-redux";
import paginationFactory from 'react-bootstrap-table2-paginator';

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";
import {VehicleDataContext} from "components/Common/PageDataContext";
import EditVehicleDataModalComponent  from './EditVehicleDataModal';
import UploadVehicleDataModalComponent  from './UploadVehicleDataExcel';
import AddVehicleDataModalComponent from "./AddVehicleData";


const VehicleDetailsTables = (props) => {
    const componentRef = useRef();
    const [Campusitems, setCampusItems] = useState([{color:"",theme:""}]);
    const [SelectedCampusitem, setSelectedCampusItem] = useState([]);
    const [selectedCampusVal, setCampusSelected] = useState();
    const [vehicledetails, setVehicleData] = useState([]);
    const Contextvalue = {vehicledetails, setVehicleData };
    const [alertmsg, setAlert] = useState([]);

    const columns = [
        {
            dataField: "VehicleID",
            text: "ID",
            hidden: true
        },
        {
            dataField: "EmployeeID",
            text: "Employee ID",
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: '165px', textAlign: 'center', backgroundColor: '#5b626b', color:'white' };
              },
        },
        {
            dataField: "VehicleOwnerName",
            text: "Owner Name",
            headerStyle: (colum, colIndex) => {
                return { width: '165px', textAlign: 'center', backgroundColor: '#5b626b', color:'white' };
              },
        },
        {
            dataField: "VehicleRegistrationNumber",
            text: "Registration Number",
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: '170px', textAlign: 'center', backgroundColor: '#5b626b', color:'white' };
              },
        },
        {
            dataField: "VehicleOwnerEmailAddress",
            text: "Email Id",
            headerStyle: (colum, colIndex) => {
                return { width: '165px', textAlign: 'center', backgroundColor: '#5b626b', color:'white' };
              },
        },
        {
            dataField: "VehicleOwnerContact",
            text: "Contact No",
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: '165px', textAlign: 'center', backgroundColor: '#5b626b', color:'white' };
              },
        },
        {
            dataField: "VehicleOwnerDept",
            text: "Department",
            sort: true,
            headerStyle: (colum, colIndex) => {
                return { width: '165px', textAlign: 'center', backgroundColor: '#5b626b', color:'white' };
              },
        },
        {
            dataField: "VehicleOwnerAddress",
            text: "Address",
            headerStyle: (colum, colIndex) => {
                return { width: '165px', textAlign: 'center', backgroundColor: '#5b626b', color:'white' };
              },
        },

        {
            dataField: "VehicleID",
            text: "Edit",
            csvExport: false,
            sort: false,
            formatter: (value, row) => (
                <VehicleDataContext.Provider value={Contextvalue}>
                    <EditVehicleDataModalComponent VehicleCurrentRowData={row} />
                </VehicleDataContext.Provider>
            ),
            headerStyle: (colum, colIndex) => {
                return { width: '60px', textAlign: 'center', backgroundColor: '#5b626b', color:'white' };
              },
        }
    ]

// This is  custom csv export component
const ExportCSV = (props) => {
    const handleClick = () => {
        props.onExport();
    };
    return (
        <Button size="sm" id="csv-tooltip"
            className="buttons-copy buttons-html5"
            color="dark" onClick={handleClick}>
            <span>Csv</span></Button>
    );
}


// this function will copy to clipboard an entire table,
// so you can paste it inside an excel or csv file
//const copyToClipboardAsTable = el => {
    const copyToClipboardAsTable = (el) => {
        var body = document.body,
            range,
            sel;
        if (document.createRange && window.getSelection) {
            range = document.createRange();
            sel = window.getSelection();
            sel.removeAllRanges();
            try {
                range.selectNodeContents(el);
                sel.addRange(range);
            } catch (e) {
                range.selectNode(el);
                sel.addRange(range);
            }
            document.execCommand("copy");
        } else if (body.createTextRange) {
            range = body.createTextRange();
            range.moveToElementText(el);
            range.select();
            range.execCommand("Copy");
        }
    
        setAlert(
            <ReactBSAlert
                success
                //   style={bsAlertStyle}
                //   title="Good job!"
                onConfirm={() => setAlert(null)}
                onCancel={() => setAlert(null)}
                confirmBtnBsStyle="info"
            >
                Copied to clipboard!
            </ReactBSAlert>
        )
    }
    useEffect(() => {
        // UserValidated
        fetch(apiEndpoint+"/GetLogCampusList",
            {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                  "strToken": sessionStorage.getItem("Clear_AuthUser")
                  
                })
              }) 
            .then(res => res.json())
            .then(
                (result) => {
                    if(result!=undefined){
                        //sessionStorage.setItem("authUser",JSON.stringify(result.strNewToken))
                    setCampusItems(JSON.parse(result.CampusList));
                    var campuslst = JSON.parse(result.CampusList);
                    setSelectedCampusItem(campuslst[0]);
                    setCampusSelected(campuslst[0].value);
                    GetVehicleDetails(campuslst[0].value);
                    }
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    //console.log(error);
                    // /setError(error);
                }
            )
    }, [])
    const changeCampusSelectHandler = (event) => {
        setSelectedCampusItem(event);
        setCampusSelected(event.value);
        GetVehicleDetails(event.value);
    };

    const GetVehicleDetails = (CampusID) => {
        // UserValidated
        fetch(apiEndpoint+"/GetVehicleDetailsList",
            {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  "intCampusID": CampusID,
                  "strToken": sessionStorage.getItem("Clear_AuthUser")
                })
            })
            .then(res => res.json())
            .then(
                (result) => {
                    if (result != undefined) {
                        //console.log(result);
                        if (result.VehicleDetailsList != undefined) {
                            if (JSON.parse(result.VehicleDetailsList).length > 0)
                                setVehicleData(JSON.parse(result.VehicleDetailsList));
                            else
                                setVehicleData([]);
                        }
                    }
                },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    //console.log(error);
                    // /setError(error);
                }
            )
        // }, [violations])
    }

    const breadcrumbItems = [
        { title: "Settings", link: "#" },
        { title: "Register Vehicle", link: "/RegisterVehicle" },
    ];

    useEffect(() => {
        props.setBreadcrumbItems('Register Vehicle', breadcrumbItems);
    })

    return (
        <React.Fragment>

            <MetaTags>
                <title>Indus | Register Vehicle</title>
            </MetaTags>
            <AvForm className="needs-validation">
            <Row>
                <Col md={2}>
                    <Select value={SelectedCampusitem} options={Campusitems}
                     onChange={changeCampusSelectHandler}></Select>
                </Col>
                <Col md={8}></Col>
                <Col md={2}>
                    <AddVehicleDataModalComponent />
                    <UploadVehicleDataModalComponent campus={SelectedCampusitem}></UploadVehicleDataModalComponent>
                </Col>
                </Row>
            </AvForm>
            <Row className="mt-3">
                <Col>
                    <Card>
                        <CardBody>
                            
                            <div className="table-responsive mt-2">
                             {alertmsg}
                            <ToolkitProvider
                                    keyField="VehicleID"
                                    data={vehicledetails}
                                    columns={columns}
                                    exportCSV={{
                                        fileName: "file.csv",
                                    }}
                                    search
                                >
                                    {
                                        props => (
                                            <div>                          
                <Row>
                  <Col xs={12} sm={6}>
                    <ButtonGroup>
                        <ExportCSV { ...props.csvProps }  /> 
                        &nbsp;                
                      <Button
                        className="buttons-copy buttons-html5"
                        color="dark"
                        size="sm"
                        id="copy-tooltip"
                        onClick={() =>
                          copyToClipboardAsTable(
                            document.getElementById("react-bs-table")
                          )
                        }
                      >
                        <span>Copy</span>
                      </Button>
                      {/* &nbsp;  
                      <ReactToPrint
                        trigger={() => (
                          <Button
                            color="dark"
                            size="sm"
                            className="buttons-copy buttons-html5"
                            id="print-tooltip"
                          >
                           <span>Print</span> 
                          </Button>
                        )}
                        content={() => componentRef.current}
                      /> */}
                    </ButtonGroup>
                    {/* <UncontrolledTooltip placement="top" target="print-tooltip">
                      This will open a print page with the visible rows of the
                      table.
                    </UncontrolledTooltip> */}
                    <UncontrolledTooltip placement="top" target="copy-tooltip">
                      This will copy to your clipboard the visible rows of the
                      table.
                    </UncontrolledTooltip>
                    <UncontrolledTooltip placement="top" target="csv-tooltip">
                      This will download table data in csv file.
                    </UncontrolledTooltip>
                  </Col>
                  <Col xs={12} sm={6}>
                    <div
                      id="datatable-basic_filter"
                      className="dataTables_filter px-4 pb-1 float-right"
                    >
                      <label>  
                        <SearchBar
                          className="form-control-sm"
                          placeholder=""
                          {...props.searchProps}
                        />
                      </label>
                    </div>
                  </Col>
                </Row>
            <BootstrapTable id="react-bs-table" 
             ref={componentRef}
            { ...props.baseProps }  
            // bootstrap4={true}
            pagination={paginationFactory({sizePerPage: 10})}/> 
                                                
            </div>
                                        )
                                    }
                                </ToolkitProvider>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </React.Fragment>
    )

}

//export default VehicleDetailsTables;
export default connect(null, { setBreadcrumbItems })(VehicleDetailsTables);